<template>
  <div id="app">
<!--    物资详情列表-->
    <div class="container">
      <el-tabs v-model="tagactiveName" >
        <el-tab-pane :label="itemparents.name" :name="'list'+itemparents.id" v-for="(itemparents,pindex) in listdata" :key="pindex">
          <el-card class="box-card" v-for="(item,iindex) in itemparents.children" :key="item.id">
            <div slot="header" class="clearfix d_header">
              <span>{{item.name}}</span>
            </div>
<!--            <img src="https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png" class="image">-->
            <div class="text_div item" v-show="item.unit">单位:{{item.unit}}</div>
            <div class="text_div item" v-show="item.spec">品牌/规格/尺寸:{{item.spec}}</div>
            <div class="text_div item" v-show="item.num">数量:{{item.num}}</div>
<!--            <div class="text_div item" v-show="item.price">单价:{{item.price}}</div>-->
            <div class="text_div item" v-show="item.note">备注:{{item.note}}</div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
var baseUrl = process.env.apiUrl + "saas/";
export default {
  data() {
    return {
      token:'',
      listdata: [],//物资列表
      tagactiveName:'',
    }
  },
  computed: {

  },
  created() {
    this.token=this.$cookies.get('token');
    this.getlist(1)
  },
  methods: {
    //获取教具列表
    getlist(type) {
      let that = this;
      that.chosetype = type;
      $.ajax({
        url: baseUrl + "jiaoju/get_list",
        type: "post",
        dataType: 'json',
        data: {
          token:that.token,
          type: type
        },
        success: function (res) {
          that.listdata = res.data;
          that.tagactiveName = 'list'+res.data[0].id
        }
      });
    },
  }
};
</script>
<style scoped>
.container{
  /*width: 1000px;*/
  height: 100%;
  /*margin: 0 auto;*/
  /*display: flex;*/
  /*justify-content: space-around;*/
  /*flex-wrap: wrap;*/
  /*background-color: lightblue;*/
  overflow-y: auto;
  margin-left: 5%;
}
.d_header{
  font-weight: bold;
}
.text_div {
  font-size: 14px;
}

.item {
  padding: 5px 0;
}
.image {
  height: 20%;
  max-width: 100%;
  display: block;
}
.box-card {
  width: 300px;
  margin:10px;
  display: inline-block;
  height: 222px;
}

</style>




// WEBPACK FOOTER //
// src/pages/jiaoju/wuziye.vue